import { type LeasingActionType } from '#types/types';

type ActionUiLanguage = 'en' | 'fr';

type ActionPanelTitleEntry = {
  en: string;
  fr: string;
};

const ACTION_PANEL_TITLES: Record<LeasingActionType, ActionPanelTitleEntry> = {
  RENT_ROLL: { en: 'Master rent roll', fr: 'État locatif' },
  DECLARE_PORTFOLIO_SIZE: {
    en: 'Declare Portfolio Size',
    fr: 'Declarer la taille du portefeuille',
  },
  DATA_GAP_NO_UNITS: {
    en: 'Unit Definition',
    fr: 'Creation des lots',
  },
  DATA_GAP_MISSING_PROPERTIES: {
    en: 'Portfolio Coverage',
    fr: 'Couverture du portefeuille',
  },
  DATA_GAP_NO_LEASING_MANAGER: {
    en: 'Manager Assignment',
    fr: 'Attribution du responsable',
  },
  DATA_GAP_NO_FLOOR_PLAN: {
    en: 'Floor Plan Upload',
    fr: 'Ajout du plan d etage',
  },
  DATA_GAP_MISSING_UNITS: {
    en: 'Floor Unit Completion',
    fr: 'Completion des lots de l etage',
  },
  DATA_GAP_MISSING_FLOORS: {
    en: 'Floor Structure Completion',
    fr: 'Completion des etages',
  },
  DATA_GAP_NO_FLOOR_CALIBRATION: {
    en: 'Plan Calibration',
    fr: 'Calibration du plan',
  },
  DATA_GAP_NO_UNIT_SURFACE: {
    en: 'Unit Surface Definition',
    fr: 'Definition de la surface du lot',
  },
  DATA_GAP_NO_UNIT_POSITION: {
    en: 'Unit Mapping',
    fr: 'Positionnement du lot',
  },
  DATA_GAP_NO_MAIN_PHOTO: {
    en: 'Media Completion',
    fr: 'Ajout de photos',
  },
  DATA_GAP_UNMAPPED_LOCATIONS: {
    en: 'TODO',
    fr: 'TODO',
  },
  RISK_ALERT_TENANT: {
    en: 'Tenant Risk Review',
    fr: 'Revue risque locataire',
  },
  VALIDATE_UNIT_STATUS: {
    en: 'Status Validation',
    fr: 'Validation statut',
  },
  DATA_GAP_NO_LEASE_END_DATE: {
    en: 'Lease Expiry Completion',
    fr: 'Ajout de la date de fin de bail',
  },
  STALE_DEAL: {
    en: 'Deal Follow-up',
    fr: 'Relance du deal',
  },
  IDENTIFY_ASSET_CANDIDATES: {
    en: 'Market Sourcing',
    fr: 'Sourcing Marche',
  },
  ORCHESTRATE_SOURCING: {
    en: 'Sourcing Center',
    fr: 'Centre de sourcing',
  },
  REVIEW_CANDIDATES: {
    en: 'Candidate Review',
    fr: 'Revue des candidats',
  },
  SELECT_INCENTIVE_TEMPLATE: {
    en: 'Incentive Template',
    fr: 'Selection du modele d incitation',
  },
  SELECT_LOI_TEMPLATE: {
    en: 'LOI Template',
    fr: 'Selection du modele LOI',
  },
  DECIDE_BASE_RENT: {
    en: 'Base Rent Decision',
    fr: 'Decision sur le loyer facial',
  },
  DECIDE_LEASE_DURATION: {
    en: 'Lease Duration Decision',
    fr: 'Decision sur la duree du bail',
  },
  DECIDE_RENT_FREE_PERIOD: {
    en: 'Rent-Free Decision',
    fr: 'Decision sur la franchise',
  },
  DECIDE_FITOUT_CONTRIBUTION: {
    en: 'Fit-Out Contribution',
    fr: 'Participation aux travaux',
  },
  DECIDE_STEP_RENTS: {
    en: 'Step Rent Schedule',
    fr: 'Definition des loyers progressifs',
  },
  VALIDATE_INCENTIVE_COVENANT: {
    en: 'Covenant Validation',
    fr: 'Validation des garanties',
  },
  ESTIMATE_TENANT_FITOUT_COST: {
    en: 'Fit-Out Cost Estimate',
    fr: 'Estimation du cout des travaux',
  },
  REDACT_INCENTIVE_LETTER: {
    en: 'Generate Incentive Pack',
    fr: 'Generation du dossier d incitation',
  },
  REDACT_LOI: {
    en: 'Redact LOI',
    fr: 'Redaction LOI',
  },
  SELECT_DEAL_CONTACT: {
    en: 'Contact Discovery',
    fr: 'Recherche de contacts',
  },
};

export const getActionPanelTitle = (
  actionType: LeasingActionType,
  lang: ActionUiLanguage = 'en'
): string => {
  const entry = ACTION_PANEL_TITLES[actionType];
  if (!entry) return actionType;
  return lang === 'fr' ? entry.fr : entry.en;
};
